import { FC } from "react";
import { useSearchParams } from "react-router-dom";

import BAAContent from "src/components/baaContent";
import FooterText from "src/components/footerText";
import GuestTopHeader from "src/components/guestTopHeader";




const BAAAgreement: FC = (): JSX.Element => {
  const [searchParams] = useSearchParams();

  const practice_name = searchParams.get("practice_name")
  const practice_address = searchParams.get("practice_address")
  const practice_created_at = searchParams.get("practice_created_at");



  return (
    <div className="overflow-auto">
      <GuestTopHeader />

      <div className="container-fluid pt-3 pb-3" style={{ paddingBottom: `5rem` }}>
        <div className="row justify-content-center">
          <div className="col-12 col-md-10">

            <div className="panel panel-default">
              <div className="panel-body">
                <BAAContent
                  practice_name={practice_name || ""}
                  practice_address={practice_address || ""}
                  practice_created_at={practice_created_at || ""}
                />
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="bg-white mt-3"><FooterText footerType="black"/></div>
    </div>
  );
};

export default BAAAgreement;
